import { CandidateSearch } from '../../models/candidate-search.models';

export interface CandidateSearchSlice {
    readonly candidates: CandidateSearch[];
    readonly selectedCandidate: CandidateSearch | undefined;
    readonly isCandidateSelected: boolean;
}

export const initialCandidateSearchSlice: CandidateSearchSlice = {
    candidates: [],
    selectedCandidate: undefined,
    isCandidateSelected: false
};
